@if (normalizedContacts().length > 0) {
  @for (contact of normalizedContacts(); track contact) {
    <a class="contact-container row" 
       [attr.href]="contact.contactDetail ? (contact.type != 'Support Link' ? ('mailto:' + contact.contactDetail) : contact.contactDetail) : null"
       [target]="contact.type == 'Support Link' ? '_blank' : '_self'"
       [attr.aria-disabled]="contact.contactDetail ? null : 'true'"
       [class.clickable]="contact.contactDetail">
      <ng-container *ngTemplateOutlet="contactContent; context: {$implicit: contact}"></ng-container>
    </a>
  }
}

<ng-template #contactContent let-contact>
  @if (!contact.image) {
    <div class="contact-image default-support">
      @if (contact.type == 'Support Group') {
        <span class="material-symbols-outlined">group</span>
      } @else if (contact.type == 'Support Link') {
        <span class="material-symbols-outlined">support_agent</span>
      } @else {
        {{contact.name.charAt(0).toUpperCase()}}
      }
    </div>
  }
  @if (contact.image) {
    <img class="contact-image" [src]="'data:image/jpeg;base64,' + contact.image"/>
  }
  <div class="col">
    <div class="contact-name">{{contact.name}}</div>
    <div class="contact-type">
      @if (contact.contactDetail) {
        <span class="material-symbols-outlined">email</span>
      } @else {
        <span class="material-symbols-outlined" aria-disabled="true">email</span>
      }
      <span>{{contact.type}}</span>
    </div>
  </div>
</ng-template>
